module.exports = __webpack_public_path__ + "static/media/bursts_25.1f522a4b.svg";